module.exports = __webpack_public_path__ + "img/rick_morty_response_character_only.eec16e7a.png";